
interface ActionButtonsProps {
  onAnotherFortune: () => void;
  onMakeYourOwn: () => void;
  onShare: () => void;
  onViewHistory: () => void;
  showButtons: boolean;
}

export default function ActionButtons({ 
  onAnotherFortune, 
  onMakeYourOwn, 
  onShare,
  onViewHistory,
  showButtons 
}: ActionButtonsProps) {
  if (!showButtons) return null;

  return (
    <div className="flex flex-col items-center gap-3 sm:gap-4 animate-slideDown px-2">
      <button
        onClick={onAnotherFortune}
        className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold text-base sm:text-lg uppercase tracking-wider border-2 sm:border-4 border-pink-400 hover:scale-105 transition-all duration-300 neon-button-purple whitespace-nowrap cursor-pointer"
        style={{ fontFamily: '"Press Start 2P", monospace' }}
      >
        <span className="text-xs sm:text-sm">🥠 Another Fortune</span>
      </button>

      <div className="flex flex-wrap justify-center gap-2 sm:gap-4 w-full">
        <button
          onClick={onMakeYourOwn}
          className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold text-sm sm:text-base uppercase tracking-wider border-2 sm:border-4 border-purple-400 hover:scale-105 transition-all duration-300 neon-button-purple whitespace-nowrap cursor-pointer flex items-center gap-2"
          style={{ fontFamily: '"Press Start 2P", monospace' }}
        >
          <i className="ri-edit-line"></i>
          <span className="text-[10px] sm:text-xs">Create Fortune</span>
        </button>

        <button
          onClick={onViewHistory}
          className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-bold text-sm sm:text-base uppercase tracking-wider border-2 sm:border-4 border-cyan-400 hover:scale-105 transition-all duration-300 neon-button-purple whitespace-nowrap cursor-pointer flex items-center gap-2"
          style={{ fontFamily: '"Press Start 2P", monospace' }}
        >
          <i className="ri-history-line"></i>
          <span className="text-[10px] sm:text-xs">View History</span>
        </button>

        <button
          onClick={onShare}
          className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold text-sm sm:text-base uppercase tracking-wider border-2 sm:border-4 border-pink-400 hover:scale-105 transition-all duration-300 neon-button-purple whitespace-nowrap cursor-pointer flex items-center gap-2"
          style={{ fontFamily: '"Press Start 2P", monospace' }}
        >
          <i className="ri-share-line"></i>
          <span className="text-[10px] sm:text-xs">Share Fortune</span>
        </button>
      </div>
    </div>
  );
}
